import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const StyledAutocompleteContainer = styled("div")`
    @media (min-width: ${breakpoints.values.lg}px) {
        pointer-events: initial;
        position: absolute;
        left: calc(50% - (100vw / 2));
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        left: calc(50% - (100vw / 2));
    }
`
